<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-brand">
        <img alt="Vue logo" src="./assets/logo.png" class="logo">
      </div>
          <div class="nav-links">
            <router-link to="/parameter-query" class="nav-link" v-if="isLoggedIn">参数查询</router-link>
            <router-link to="/my-certification" class="nav-link" v-if="isLoggedIn">我的认证</router-link>
            <router-link to="/certification" class="nav-link" v-if="!isLoggedIn">代理商认证</router-link>
            <router-link to="/project-report" class="nav-link" v-if="isLoggedIn && isCertified">项目报备</router-link>
            <router-link to="/my-report" class="nav-link" v-if="isLoggedIn && isCertified">我的报备</router-link>
            <router-link to="/excellent-representative-application" class="nav-link" v-if="isLoggedIn && isCertified">渠道优秀代表申请</router-link>
            <router-link to="/login" class="nav-link" v-if="!isLoggedIn">登录</router-link>
            <button @click="logout" class="nav-link logout-btn" v-if="isLoggedIn">退出登录</button>
          </div>
    </nav>
    <main class="main-content">
      <router-view />
    </main>
    <footer class="app-footer">
      <div class="footer-content">
        <span>版权所有 北京甲信技术有限公司 保留一切权利</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer" class="icp-link">
          京ICP备2021020334号-1
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    },
    isCertified() {
      const userInfo = this.$store.getters['user/userInfo']
      return userInfo?.status === 'approved'
    }
  },
  methods: {
    async logout() {
      try {
        await this.$store.dispatch('user/logout')
        this.$router.push('/login')
      } catch (error) {
        console.error('Logout error:', error)
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo {
  height: 40px;
  width: auto;
  max-width: 150px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.brand-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.nav-links {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.nav-link {
  text-decoration: none;
  color: #2c3e50;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.nav-link:hover {
  background-color: #f0f0f0;
  color: #42b883;
}

.nav-link.router-link-active {
  color: #42b883;
  font-weight: bold;
}

.logout-btn {
  background-color: #ff4757;
  color: white !important;
}

.logout-btn:hover {
  background-color: #ff3838;
}

.main-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 200px);
}

.app-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 1.5rem 2rem;
  margin-top: 2rem;
  text-align: center;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 0.875rem;
  color: #6c757d;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.icp-link {
  color: #007bff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  
  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .main-content {
    padding: 1rem;
  }
  
  .app-footer {
    padding: 1rem;
  }
  
  .footer-content {
    font-size: 0.8rem;
    flex-direction: column;
    gap: 0.25rem;
  }
}
</style>
